// eslint-disable-next-line import/prefer-default-export
export const ROOM_STATUS = {
  READY: 'ready',
  WAITING: 'waiting',
  COMPLETED: 'complete',
  PENDING: 'pending',
};
